import { useState } from "react";
import { Menu, X } from "lucide-react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const linkClasses = "cursor-pointer py-2 transition-colors duration-200";
  const activeClasses =
    "text-orange-400 font-bold border border-orange-400 px-3 py-2 rounded-md";

  return (
    <nav className="flex justify-between items-center bg-white px-4 md:px-12 py-4 shadow-lg">
      {/* Logo */}
      <div className="flex items-center space-x-2">
        <img src="./Care-logo.png" alt="Logo 2" className="h-[61px] w-auto" />
      </div>

      {/* Desktop Links */}
      <div className="hidden md:flex space-x-8 lg:space-x-12 font-medium font-raleway text-orange-900">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            isActive ? activeClasses : "text-orange-900 font-bold" + linkClasses
          }
        >
          Home
        </NavLink>
        <NavLink
          to="/courses"
          className={({ isActive }) =>
            isActive ? activeClasses : "text-orange-900  " + linkClasses
          }
        >
          Courses
        </NavLink>
        <NavLink
          to="/blog"
          className={({ isActive }) =>
            isActive ? activeClasses : "text-orange-900" + linkClasses
          }
        >
          Blog
        </NavLink>
        <NavLink
          to="/about"
          className={({ isActive }) =>
            isActive ? activeClasses : "text-orange-900  " + linkClasses
          }
        >
          About Us
        </NavLink>
        <NavLink
          to="/contact"
          className={({ isActive }) =>
            isActive ? activeClasses : "text-orange-900 " + linkClasses
          }
        >
          Contact
        </NavLink>
      </div>

      {/* Desktop Button */}
      {/* <div className="hidden md:block">
        <a
          className="bg-orange-500 hover:bg-orange-600 font-raleway text-white px-3 py-3 rounded-md ml-2"
          href="https://drive.google.com/drive/folders/1HbuI8Wt-NfSr92fhXN1cCzrVoeRriAzs?usp=sharing"
          target="_blank"
        >
          Become a Learner →
        </a>
      </div> */}

      {/* Mobile Menu Button */}
      <div className="md:hidden">
        <button onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="absolute top-[70px] left-0 w-full bg-white shadow-md z-50 md:hidden">
          <div className="flex flex-col items-center space-y-4 py-6 font-bold font-raleway">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                isActive ? activeClasses : "text-orange-900 " + linkClasses
              }
              onClick={() => setMenuOpen(false)}
            >
              Home
            </NavLink>
            <NavLink
              to="/courses"
              className={({ isActive }) =>
                isActive ? activeClasses : "text-orange-900 " + linkClasses
              }
              onClick={() => setMenuOpen(false)}
            >
              Courses
            </NavLink>
            <NavLink
              to="/blog"
              className={({ isActive }) =>
                isActive ? activeClasses : "text-orange-900 " + linkClasses
              }
              onClick={() => setMenuOpen(false)}
            >
              Blog
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                isActive ? activeClasses : "text-orange-900 " + linkClasses
              }
              onClick={() => setMenuOpen(false)}
            >
              About Us
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) =>
                isActive ? activeClasses : "text-orange-900 " + linkClasses
              }
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </NavLink>
            {/* <a
              className="bg-orange-500 hover:bg-orange-600 font-raleway text-white px-3 py-2 rounded-md"
              href="https://drive.google.com/drive/folders/1HbuI8Wt-NfSr92fhXN1cCzrVoeRriAzs?usp=sharing"
              target="_blank"
            >
              Become a Learner →
            </a> */}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
